export default __webpack_public_path__ + "static/media/SignPainter.3a551eb8.ttf";